var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('info',[(_vm.isLoading)?_c('loader'):_vm._e(),_c('html-with-links',{attrs:{"html":_vm.content.text}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }